<template>
    <div class="cookie-content">
        <div class="cookie-inner">
            <!-- 1. 左侧 Logo 区 -->
            <div class="logo-section" v-if="screenWidth > 768">
                <img src="https://blhc806.oss-cn-hangzhou.aliyuncs.com/wmUsImg/sysImg/logo@2x.png" alt="Logo" />
            </div>

            <!-- 2. 中间文字/设置区 -->
            <div class="main-section">
                <!-- 初始视图：摘要说明 -->
                <div v-if="isAll" class="summary-view">
                    <div class="title">We Use Cookies</div>
                    <div class="desc">
                        We Use Necessary Cookies To Make Our Website Work Properly, Including Login And Shopping Cart
                        Functions.
                        We Also Use Cookies To Remember Your Preferences, Analyze Site Usage. And Improve Our Services.
                        <br />
                        By Using This Site. You Agree To Our Privacy Policy And Cookie Policy.
                    </div>
                </div>

                <!-- 设置视图：详细开关 -->
                <div v-else class="settings-view">
                    <div class="setting-item">
                        <el-switch v-model="isTrue1" active-color="#58473D" inactive-color="#D8D8D8" disabled />
                        <div class="setting-text">
                            <span class="label">Necessary Cookies (always Active):</span>
                            <span class="detail">required For Login, Shopping Cart, And Basic Website Functions. Cannot
                                Be Disabled.</span>
                        </div>
                    </div>
                    <div class="setting-item">
                        <el-switch v-model="isTrue2" active-color="#58473D" inactive-color="#D8D8D8" />
                        <div class="setting-text">
                            <span class="label">Performance & Analytics Cookies:</span>
                            <span class="detail">help Us Understand How Visitors Use Our Website, Measure Site
                                Performance, And Improve Our Services.</span>
                        </div>
                    </div>
                    <div class="setting-item">
                        <el-switch v-model="isTrue3" active-color="#58473D" inactive-color="#D8D8D8" />
                        <div class="setting-text">
                            <span class="label">Functional Cookies:</span>
                            <span class="detail">help Us Understand How Visitors Use Our Website, Measure Site
                                Performance, And Improve Our Services.</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 3. 右侧按钮区 -->
            <div class="action-section">
                <!-- 初始视图按钮 -->
                <div v-if="isAll" class="btn-group-vertical">
                    <button class="btn-outline" @click="isAll = false">Cookie Settings</button>
                    <button class="btn-outline" @click="handleAcceptNecessary">Accept Necessary</button>
                    <button class="btn-filled" @click="handleAcceptAll">Accept All</button>
                </div>
                <!-- 设置视图按钮 -->
                <div v-else class="btn-group-vertical">
                    <button class="btn-outline" @click="isAll = true">Cancel</button>
                    <button class="btn-filled" @click="handleSave">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from "js-cookie"; // 引入插件
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            isAll: true,
            isTrue1: true,
            isTrue2: true,
            isTrue3: true,
        };
    },
    computed: {
        ...mapGetters("app", ["getScreenWidth", "isMobile"]),
        screenWidth() {
            return this.getScreenWidth;
        },
    },
    methods: {
        handleAcceptAll() {
            this.isTrue2 = true;
            this.isTrue3 = true;
            this.setCookieAndClose();
        },
        handleAcceptNecessary() {
            this.isTrue2 = false;
            this.isTrue3 = false;
            this.setCookieAndClose();
        },
        handleSave() {
            this.setCookieAndClose();
        },
        setCookieAndClose() {
            // 1. 设置 Cookie 标记
            // expires: 1 表示 1 天后失效
            Cookies.set("aly_cookie_status", "accepted", { expires: 365 });
            const preferences = {
                performance: this.isTrue2,
                functional: this.isTrue3
            };
            localStorage.setItem('cookie-preferences', JSON.stringify(preferences));

            // 3. 通知父组件 (App.vue) 关闭 Drawer
            this.$emit("close");
        }
    },
};
</script>

<style scoped lang="scss">
.cookie-content {
    width: 100%;
    height: 180px;
    background: #ffffff;
    border-top: 1px solid #e0e0e0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "NotoSerif", serif;
}

.cookie-inner {
    width: 100%;
    max-width: 1400px;
    padding: 0 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

/* 左侧 Logo */
.logo-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 120px;

    img {
        width: 65px;
        height: 65px;
        margin-bottom: 5px;
    }

    .brand-name {
        font-size: 12px;
        font-weight: bold;
        color: #58473e;
        letter-spacing: 1px;
    }
}

/* 中间内容区 */
.main-section {
    flex: 1;
    padding: 0 60px;
    color: #58473e;

    .summary-view {
        .title {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 8px;
        }

        .desc {
            font-size: 14px;
            line-height: 1.6;
        }
    }

    .settings-view {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .setting-item {
            display: flex;
            align-items: flex-start;
            /* 对齐开关和多行文字 */
            gap: 20px;

            ::v-deep .el-switch {
                margin-top: 2px;
            }
        }

        .setting-text {
            font-size: 13px;
            line-height: 1.4;

            .label {
                font-weight: bold;
            }

            .detail {
                color: #7a6e67;
                margin-left: 5px;
            }
        }
    }
}

/* 右侧按钮区 */
.action-section {
    width: 180px;

    .btn-group-vertical {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    button {
        width: 100%;
        height: 38px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        transition: all 0.3s;
        font-family: inherit;
    }

    .btn-outline {
        background: #ffffff;
        border: 1px solid #58473e;
        color: #58473e;

        &:hover {
            background: #f5f2f0;
        }
    }

    .btn-filled {
        background: #58473e;
        border: 1px solid #58473e;
        color: #ffffff;

        &:hover {
            background: #463932;
        }
    }
}

/* 响应式微调 */
@media screen and (max-width: 1200px) {
    .main-section {
        padding: 0 30px;
    }
}

.cookie-content {
    width: 100%;
    padding: 30px 0;
    background: #ffffff;
    border-top: 1px solid #e0e0e0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "NotoSerif", serif;
}

@media screen and (max-width:768px) {
    .cookie-content{
        height: 800px !important;
    }
    .cookie-inner{
        max-width: 100% !important;
    }
    .title{
        font-size: 4rem !important;
    }
    .desc{
        font-size: 3rem !important;
    }
    .action-section {
        width: 360px;
    }
    .action-section button{
        height: 140px !important;
        font-size: 2rem;
    }
    .setting-text{
        font-size: 2rem !important;
    }

}
</style>